module.exports = __webpack_public_path__ + "img/print_check_checked.dfe733f2.svg";